import {forwardRef, useEffect, useState} from 'react';
import ClearInput from 'components/Form/FormComponents/ClearInput';

const FuzzySearchInput = forwardRef( ({
    onQueryChange = null,
    timeoutDuration = 50,
    placeholder = "Begin typing to search...",
    ...otherProps
}, ref) => {
    const [query, setQuery] = useState('');
    const [prevQuery, setPrevQuery] = useState(query);
    const [fuzzySearchTimeout, setFuzzySearchTimeout] = useState(null);

    useEffect(() => {
        if (!onQueryChange || typeof onQueryChange !== 'function') {
            return;
        }

        if (query === prevQuery) {
            return;
        }

        clearTimeout(fuzzySearchTimeout);
        setFuzzySearchTimeout( setTimeout( () => {
            onQueryChange(query);
            setFuzzySearchTimeout(null);
        }, timeoutDuration ) );
    }, [query]);

    const onChangeHandler = (e) => {
        const val = e.target.value;

        if (val !== query) {
            setPrevQuery(query);
            setQuery(val);
        }
    }

    return (
        <ClearInput
            ref={ref}
            value={query}
            onChange={onChangeHandler}
            onClear={() => setQuery('')}
            placeholder={placeholder}
            isFormField={false}
            noMargin
            {...otherProps}
        />
    );
} );

export default FuzzySearchInput;
